<template>
  <div class="page page-404">
    <headercomponent ref="header"></headercomponent>
    <div class="content" v-if="!dataLoaded"></div>
    <div class="content" v-else>
      <section class="inner-content">
        <h1 v-html="pageData.title.rendered"></h1>
        <div class="image" v-html="pageData.content.rendered"></div>
      </section>
    </div>
  </div>
</template>

<script>
import getPage from '@/mixins/getPage';
import HeaderComponent from '@/components/Modules/HeaderComponent';

export default {
  name: 'Page404',
  mixins: [getPage],
  data() {
    return {
      pageID: {
        de: 82,
        fr: 23,
      },
    };
  },
  components: {
    headercomponent: HeaderComponent,
  },
};
</script>

<style lang="scss" scoped>
.content /deep/ .lost {
  height: 700px;
  background-size: cover;
  background-position: center center;
  margin-top: 65px;
}
</style>



// WEBPACK FOOTER //
// src/components/Page404.vue